// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3zx65","lds-ripple":"Loader_lds-ripple__uai5F","center":"Loader_center__1LGkT"};